<!--
 * @Description: 学生 详情  家校联系记录
 * @Author: PF
 * @Date: 2023-12-01 11:19:38
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 14:19:36
-->
<template>
  <div class="hp100">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="学期" prop="xqmc" align="center" />
      <el-table-column label="日期" prop="rq" width="100" align="center" />
      <el-table-column label="联系内容" prop="lxnr" min-width="150" align="center" />
      <el-table-column label="效果" prop="xg" min-width="150" align="center" />
    </el-table>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])

watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/xuesheng/banzhurengongzuojiaxiaolianxijilu/list', data: tableData, parms: { xsid: props.row.id, order: 'rq', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>
